module.exports = __webpack_public_path__ + "img/office.2f3193e1.svg";